import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useBooking } from "../context/BookingContext";

const links = [
  { label: "Artistry", href: "#artistry" },
  { label: "The Scalp Lounge", href: "#scalp-lounge" },
  { label: "Bridal Lookbook", href: "#lookbook" },
  { label: "The Studio", href: "#studio" },
];

export const Navbar = () => {
  const { openBooking } = useBooking();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-[#E8E2D2]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#top"
          data-testid="nav-logo"
          className={`font-serif text-xl md:text-2xl font-light uppercase tracking-[0.25em] transition-colors duration-500 ${
            scrolled ? "text-obsidian" : "text-[#FDFBF7]"
          }`}
        >
          Picaso<span className="text-champagne">.</span>
        </a>

        {/* Center links */}
        <ul className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`underline-grow text-xs uppercase tracking-[0.18em] font-light transition-colors duration-500 ${
                  scrolled ? "text-obsidian/80 hover:text-obsidian" : "text-[#FDFBF7]/85 hover:text-[#FDFBF7]"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden lg:block">
          <button
            data-testid="nav-book-button"
            onClick={() => openBooking()}
            className={`underline-grow text-xs uppercase tracking-[0.18em] font-normal transition-colors duration-500 ${
              scrolled ? "text-obsidian" : "text-[#FDFBF7]"
            }`}
          >
            Secure a Consultation
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className={`lg:hidden transition-colors duration-500 ${scrolled ? "text-obsidian" : "text-[#FDFBF7]"}`}
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#FDFBF7]/95 backdrop-blur-xl border-t border-[#E8E2D2] px-6 py-8"
        >
          <ul className="flex flex-col gap-6">
            {links.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  onClick={() => setMobileOpen(false)}
                  className="font-serif text-2xl font-light text-obsidian"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <button
                data-testid="mobile-book-button"
                onClick={() => {
                  setMobileOpen(false);
                  openBooking();
                }}
                className="mt-2 text-xs uppercase tracking-[0.18em] text-champagne"
              >
                Secure a Consultation
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
